<div style="height: 20px">
    <span *ngIf="!bigFont">{{ specialty }}</span>
    <span *ngIf="bigFont">{{ specialty }}</span>

    <span *ngIf="specialization != ''">{{ specialization }}</span>
</div>
